import React, { useState, useEffect, useRef } from 'react';
import { Auth, Logger } from 'aws-amplify';
import { Container, Form, InputGroup, Button } from 'react-bootstrap';
import { JRemoveAccount } from '../components/auth';
import { Message } from '../components/utils';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate } from 'react-router-dom';
const logger = new Logger('Profile');

const Profile = (props) => {
  const [error, setError] = useState('');
  const { user } = useAuthenticator((context) => [context.user]);
  const profile = user ? { 'family_name': user.attributes['family_name'], 'name': user.attributes['name'], 'custom:birthdate': user.attributes['custom:birthdate'], 'custom:kvsID': user.attributes['custom:kvsID'] } : undefined;
  const [state, setState] = useState(profile);
  const [sticky, setSticky] = useState(false);
  const timerRef = useRef(null);
  const verified = (user && user.attributes && user.attributes['custom:ID']) || 0;
  let message = '';

  const handleInputChange = (attribute, value) => {
    if (verified >= 10 && attribute === 'custom:kvsID') {
      handleError('Die ID ist nicht mehr änderbar.')
      return;
    }
    const profile = Object.assign({}, state.profile);
    profile[attribute] = value;
    setSticky(true);
    setState({ profile });
  };

  function clearTimer() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }

  const OK = true;
  function checkDate(date) {
    // console.log(date)
    const separator = '.';
    const bits = date.split(separator);
    const d = new Date(bits[2], bits[1] - 1, bits[0])
    // console.log(`${d}: ${d.getFullYear()}.${d.getMonth() +1}:: ${bits[2]}, ${bits[1]}, ${bits[0]}`)
    return d.getFullYear() === parseInt(bits[2]) && d.getMonth() + 1 === parseInt(bits[1]);
  }

  function checkAttributes() {
    if (state && state.profile) {
      if (Object.entries(state.profile).forEach((item, index) => {
        const [key, value] = Object.entries(state.profile)[index];
        if (value === '') {
          switch (key) {
            case 'custom:kvsID':
              handleError('Die ID darf nicht leer sein.');
              return false;
            case 'family_name':
              handleError('Der Nachname darf nicht leer sein.');
              return false;
            case 'name':
              handleError('Der Vorname darf nicht leer sein.')
              return false;
            case 'custom:birthdate':
              handleError('Das Geburtsdatum darf nicht leer sein.')
              return false;
            default:
              break;
          }
        }
        if (key === 'custom:birthdate' && value.length > 10) {
          handleError('Bitte ein gültiges Geburtsdatum eingeben (zu lang).')
          return false;
        }
        if (key === 'custom:birthdate' && value.length < 10) {
          handleError('Bitte ein gültiges Geburtsdatum eingeben (zu kurz).')
          return false;
        }
        if (key === 'custom:birthdate' && checkDate(value) !== OK) {
          handleError('Bitte ein gültiges Geburtsdatum eingeben.')
          return false;
        }

        return true;
      }) === false) {
        return false;
      }
      return true;
    }
  }

  const saveProfile = () => {
    if (!user) {
      handleError('Kein Benutzer vorhanden? - interner Fehler, bitte EDV kontaktieren');
      return;
    }
    if (checkAttributes()) {
      Auth.updateUserAttributes(user, state.profile)
        .then((data) => { saveSuccess(data); setSticky(false); })
        .catch(err => handleError(err));
    }
    //      props.history.push('/home');
  };

  const saveSuccess = (data) => {
    logger.info('returned profile', data);
    console.log(data)
    //    dispatch(updateProfile(data));
  }

  const handleError = (error) => {
    logger.info('load / save user attributes error', error);
    console.log(error)
    clearTimer();
    timerRef.current = setTimeout(() => setError(''), 5000);
    setError(error.message || error);
  }

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  switch (verified) {
    case 0:
      message = 'Ihre Daten werden heute Abend verifiziert und der Account ist dann ab morgen freigeschaltet. Bitte schliessen Sie die Seite.';
      break;
    case 1:
      message = 'Die Daten konnten nicht zugeordnet werden; das Konto wird morgen gelöscht. Bitte schliessen Sie die Seite.';
      break;
    default:
      if (verified > 1 && verified < 9) {
        message = 'Die Daten konnten nicht zugeordnet werden; das Konto wird in ' + verified + ' Tagen gelöscht. Bitte schliessen Sie die Seite';
      }
      break;
  }

  return (
    <>
      {profile ?
        <Container className='starter-template'>
          <h4 style={{ marginTop: '180px' }}>Profil bearbeiten</h4>
          <InputGroup style={{ maxWidth: '24rem', margin: 'auto' }}>
            <InputGroup.Text style={{ minWidth: '7rem' }} id="Vorname">Vorname</InputGroup.Text>
            <Form.Control
              placeholder="Vorname"
              aria-label="Vorname"
              aria-describedby='Vorname'
              defaultValue={profile.name || ''}
              onChange={event => handleInputChange('name', event.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ maxWidth: '24rem', margin: 'auto' }}>
            <InputGroup.Text style={{ minWidth: '7rem' }} id="Nachname">Nachname</InputGroup.Text>
            <Form.Control
              placeholder="Nachname"
              aria-label="Nachname"
              aria-describedby='Nachname'
              defaultValue={profile.family_name || ''}
              onChange={event => handleInputChange('family_name', event.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ maxWidth: '24rem', margin: 'auto' }}>
            <InputGroup.Text style={{ minWidth: '7rem' }} id="custom:birthdate">Geburtstag</InputGroup.Text>
            <Form.Control
              placeholder="01.01.1987"
              aria-label="Geburtstag"
              aria-describedby='Geburtstag'
              defaultValue={profile['custom:birthdate'] || ''}
              onChange={event => handleInputChange('custom:birthdate', event.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ maxWidth: '24rem', margin: 'auto' }}>
            <InputGroup.Text style={{ minWidth: '7rem' }} id="ID">ID</InputGroup.Text>
            <Form.Control
              type='number'
              placeholder="ID"
              aria-label="ID"
              aria-describedby='ID'
              defaultValue={profile['custom:kvsID'] || ''}
              disabled={(verified >= 10) ? "disabled" : ""}
              onChange={event => handleInputChange('custom:kvsID', event.target.value)}
            />
          </InputGroup>
          <p></p>
          {sticky && <>
            <Button variant="primary" px="5" style={{ minWidth: '7rem' }} onClick={saveProfile}>Speichern</Button>&nbsp;&nbsp;</>}
          <JRemoveAccount user={user} />
          {error > '' && <><p></p><Message children={error} /></>}
          {message > '' && <><p></p><Message variant="info" text="white" children={message} /></>}
        </Container>
        : <Navigate to='/login' replace={true} />

      }
    </>
  )
}

export default Profile;